export const languageOptions = () => {
  return [
    { label: "English", value: "en" },
    { label: "العربية", value: "ar" },
  ]
}
